import styled from 'styled-components';
import { zIndex } from 'tokens';

export const Workspace = styled.div`
	flex: 1;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	isolation: isolate;
`;

export const Panels = styled.div`
	z-index: ${zIndex.panel};
`;

export const LeftPanels = styled.div`
	position: absolute;
	display: flex;
	top: 0px;
	bottom: 0px;
`;

export const RightPanels = styled.div`
	position: absolute;
	display: flex;
	top: 0px;
	bottom: 0px;
	right: 0;
`;

interface IslandProps {
	left: number;
}

export const Island = styled.div<IslandProps>`
	display: flex;
	align-items: end;
	gap: 8px;
	position: absolute;
	bottom: 14px;
	left: ${({ left }) => left}px;
	transform: translateX(-50%);
	z-index: ${zIndex.island};
`;
